/**
 * Moduł do zarządzania sekcją "Kupuję jako"
 * Publikuje zdarzenia:
 * - DELIVERY_BUYER_TAX_ID_TYPE_CHANGED - zmiana typu identyfikatora podatkowego
 */
app.service('deliveryBuyerDetails', function (orderConfig, orderClass, vies, regon, companyName, select, validate, broker) {

	let $self, $taxIdTypeBoxes, $taxIdentifierSelector, $vatUe, $nip, $idNumber, $numberIdCountryCode, $vatUeCountryCode, $companyName;
	let config;
	let isOneInit = false;

	function init($deliveryForm) {
		config = orderConfig.getData();
		setElements($deliveryForm);
		setEvents($deliveryForm);
	}

	function setElements($deliveryForm) {
		$self = $deliveryForm.find('#buyer-details');
		$taxIdTypeBoxes = $self.find('.tax-id-type-box');
		$vatUe = $self.find('#vat-ue');
		$nip = $self.find('#nip');
		$idNumber = $self.find('#id-number');
		$numberIdCountryCode = $self.find('#number-id-country-code');
		$vatUeCountryCode = $self.find('#vat-ue-country-code');
		$companyName = $self.find('#company-name-textarea');
		$taxIdentifierSelector = $self.find('#tax-identifier-selector');
	}

	function setEvents($deliveryForm) {
		$taxIdentifierSelector.on('change', handleTaxIdentifierChange);

		$('#id-number-div').on('input', function () {
			$idNumber.val($(this).text());
			validate.element($idNumber, $deliveryForm);
		});

		companyName.init('company-name');

		let $viesButton = $self.find('.js-vies-button');

		vies.init({
			$box: $self.find('.vies-box'),
			$button: $viesButton,
			$vatNumber: $vatUe,
			$country: $vatUeCountryCode,
			$taxIdSelector: $taxIdentifierSelector,
			nipEuValidate: config.nipEuValidate,
			validatedVatUeNumbers: config.validatedVatUeNumbers,
			onVatUeValidationUpdated: triggerVatUeValidation
		});

		// wymuszamy weryfikację VIES dla klienta powracającego
		if ($viesButton.length && !$viesButton.is(':disabled')) {
			triggerVatUeValidation();
			validate.scrollToError();
		}

		regon.init({
			$country: $('#country-code'),
			$box: $self.find('.regon-box'),
			$nip: $self.find('#nip'),
			$companyName: $self.find('#company-name-textarea-div'),
			$city: $('#city-name'),
			$street: $('#home-street'),
			$houseNumber: $('#home-house-number'),
			$flatNumber: $('#home-flat-number'),
			$zipCode: $('#zip-code')
		});
		if (!isOneInit) {
			isOneInit = true;
			broker.on('VIES_VERIFICATION_FINISHED', function (event, result) {
				if (result.success) {
					updateValidatedVatUeNumbersConfig(result.countryCode, result.vatUeNumber);
					triggerVatUeValidation();
				}
			});
		}

		function updateValidatedVatUeNumbersConfig(countryCode, vatUeNumber) {
			if (!config.validatedVatUeNumbers.some(entry => entry[countryCode] && entry[countryCode].includes(vatUeNumber))) {
				config.validatedVatUeNumbers.push({ [countryCode]: [vatUeNumber] });
			}
		}

		function triggerVatUeValidation() {
			validate.element($vatUeCountryCode, $deliveryForm);
			validate.element($vatUe, $deliveryForm);
		}
	}

	function handleTaxIdentifierChange() {

		config.deliveryInfo.taxIdType = $(this).val();

		select.clear($numberIdCountryCode);
		select.clear($vatUeCountryCode);

		broker.trigger('DELIVERY_BUYER_TAX_ID_TYPE_CHANGED');

		render();
	}

	function render() {

		const isCompanyUserType = config.deliveryInfo.frontUserType === "COMPANY";

		orderClass.toggle('user-type-company', isCompanyUserType);
		orderClass.toggle('user-type-individual', !isCompanyUserType);

		setTaxIdTypeBox();
		updateValidation();
	}

	function setTaxIdTypeBox() {
		$taxIdTypeBoxes
			.removeClass('active')
			.filter((i, el) => el.dataset.type === config.deliveryInfo.taxIdType)
			.addClass('active');
	}

	function setFieldState($field, shouldBeIgnored) {
		if ($field.hasClass('ignore') !== shouldBeIgnored) {
			$field.ignore(shouldBeIgnored);
		}
	}

	function updateValidation() {
		const taxIdType = config.deliveryInfo.taxIdType;
		const companyFieldsDisabled = config.deliveryInfo.frontUserType !== 'COMPANY';

		$numberIdCountryCode.prop('disabled', taxIdType !== "NUMBER_ID");
		$vatUeCountryCode.prop('disabled', taxIdType !== "VAT_UE");

		setFieldState($nip, companyFieldsDisabled || taxIdType !== 'NIP');
		setFieldState($vatUe, companyFieldsDisabled || taxIdType !== 'VAT_UE');
		setFieldState($vatUeCountryCode, companyFieldsDisabled || taxIdType !== 'VAT_UE');
		setFieldState($idNumber, companyFieldsDisabled || taxIdType !== 'NUMBER_ID');
		setFieldState($numberIdCountryCode, companyFieldsDisabled || taxIdType !== 'NUMBER_ID');
		setFieldState($companyName, companyFieldsDisabled);
	}

	return {
		init,
		render
	};
});
